/// <amd-module name="VSSUI/Components/Panel/PanelCloseButton" />
import * as React from "react";

import { Button } from "VSSUI/Button";
import * as Resources from "VSSUI/Resources.Layer";
import { css } from "VSSUI/Util";

import { IPanelCloseButtonProps, PanelCloseButtonSize } from "VSSUI/Components/Panel/Panel.Props";

export const PanelCloseButton: React.SFC<IPanelCloseButtonProps> = props => {
    return (
        <Button
            className={css(props.className, "close-button")}
            ariaLabel={Resources.Close}
            iconProps={{ iconName: props.size === PanelCloseButtonSize.small ? "Cancel" : "Clear" }}
            onClick={props.onDismiss}
            subtle={true}
            tooltipProps={{
                showOnFocus: true,
                text: Resources.Close
            }}
        />
    );
};
